export function usePrice(props) {
  const changePrice = () => {
    return !props.setLocalStorageSelectPrice
      ? undefined
      : localStorage.getItem(props.setLocalStorageSelectPrice)
      ? localStorage.getItem(props.setLocalStorageSelectPrice) == 'true'
        ? true
        : false
      : true
  }
  const changeMainPrice = () => {
    return localStorage.getItem(props.setLocalStorageSelectPrice)
      ? localStorage.getItem(props.setLocalStorageSelectPrice) == 'true'
        ? true
        : false
      : true
  }

  return {
    changePrice,
    changeMainPrice,
  }
}
